import * as React from "react"

/**
 * 设备交互模式检测：触屏设备（手机/平板）为 coarse pointer。
 * 与 CSS 宽度断点分离使用，避免手机横屏旋转后被误判为桌面布局。
 */
export function useIsCoarsePointer() {
  const [isCoarsePointer, setIsCoarsePointer] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia("(pointer: coarse)")
    const onChange = () => {
      setIsCoarsePointer(mql.matches)
    }
    mql.addEventListener("change", onChange)
    setIsCoarsePointer(mql.matches)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isCoarsePointer
}
